import React, { useState } from 'react';
import { showableCartInstance } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import { cartInstance } from 'ReactApp/Ddd/Aggregates/Cart';

type PromoCodeFormV1Props = {
    value?: string | React.JSX.Element | Function,
    subvalue?: string | React.JSX.Element | Function,
    classes?: string[]
}

const PromoCodeFormV1 = (props: PromoCodeFormV1Props) => {
    const [
        lastErrorMessage,
        setLastErrorMessage
    ] = useState('');
    const [
        processingStatus,
        setProcessingStatus
    ] = useState(false);
    const [
        promoCodeValue,
        setPromoCodeValue
    ] = useState(showableCartInstance.promoInfo.promoCode);
    const [
        currentStatus,
        setCurrentStatus
    ] = useState((
        showableCartInstance.promoInfo.promoCode === null
            ? false
            : true
    ));

    const applyPromoCodeHandler = async (e) => {
        setLastErrorMessage('');
        setProcessingStatus(true);
        await cartInstance.applyPromoCode((promoCodeValue as string)).then(data => {
            if (data === true) {
                setCurrentStatus(true);
                showableCartInstance.reinitialize();
            } else {
                setLastErrorMessage(data as string);
            }
            setProcessingStatus(false);
        }).catch(err => {
            setProcessingStatus(false);
        });
    }

    const cancelPromoCodeHandler = async (e) => {
        setLastErrorMessage('');
        setProcessingStatus(true);
        await cartInstance.cancelPromoCode().then(data => {
            if (data === true) {
                setCurrentStatus(false);
                setPromoCodeValue('');
                showableCartInstance.reinitialize();
            }
            setProcessingStatus(false);
        }).catch(err => {
            setProcessingStatus(false);
        });
    }

    return (
        <div className="form__input-item _promo">
            <input 
                type="text" 
                name="promo-code" 
                className="form__input js-text-input js-promo-input" 
                placeholder="промокод" 
                value={promoCodeValue || ''}
                readOnly={
                    (
                        currentStatus === true 
                            ? true 
                            : false
                    )
                }
                onChange={(e) => {
                    setPromoCodeValue(e.target.value);
                }}
                onKeyUp={e => e.key === 'Enter' && applyPromoCodeHandler(e)}
            />
            <button 
                type="button" 
                className={
                    "order__promo-apply js-promo"
                    + (
                        currentStatus === true 
                            ? ' hidden' 
                            : ''
                    )
                }
                disabled={processingStatus}
                onClick={applyPromoCodeHandler}
                >
                    Применить
            </button>
            <button 
                type="button" 
                className={
                    "order__promo-remove js-promo-remove"
                    + (
                        currentStatus === false 
                            ? ' hidden' 
                            : ''
                    )
                }
                onClick={cancelPromoCodeHandler}
                disabled={processingStatus}
                >
                    Отменить
            </button>
            <div 
                className={
                    `order__promo-error js-promo-error`
                    + (
                        lastErrorMessage === '' 
                            ? ' hidden' 
                            : ''
                    )
                }
                >
                {lastErrorMessage}
            </div>
        </div>
    );

}

export default PromoCodeFormV1;